import { SvgIcon, SvgIconProps } from '@mui/material';

export function CloseIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33 5.5C17.8475 5.5 5.5 17.8475 5.5 33C5.5 48.1525 17.8475 60.5 33 60.5C48.1525 60.5 60.5 48.1525 60.5 33C60.5 17.8475 48.1525 5.5 33 5.5ZM42.24 39.325C43.0375 40.1225 43.0375 41.4425 42.24 42.24C41.8275 42.6525 41.305 42.845 40.7825 42.845C40.26 42.845 39.7375 42.6525 39.325 42.24L33 35.915L26.675 42.24C26.2625 42.6525 25.74 42.845 25.2175 42.845C24.695 42.845 24.1725 42.6525 23.76 42.24C22.9625 41.4425 22.9625 40.1225 23.76 39.325L30.085 33L23.76 26.675C22.9625 25.8775 22.9625 24.5575 23.76 23.76C24.5575 22.9625 25.8775 22.9625 26.675 23.76L33 30.085L39.325 23.76C40.1225 22.9625 41.4425 22.9625 42.24 23.76C43.0375 24.5575 43.0375 25.8775 42.24 26.675L35.915 33L42.24 39.325Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
